export default __webpack_public_path__ + "static/Brico_Cookie Policy v1.0-2e8d04ecbbc10dc63f87decd90602d0e.pdf";